import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

import type { Mode } from '#src/lib/gameMode.ts';

type BoardViewUpdate = {
  lastVisitedMode?: Mode;
  lastVisitedBoardTitle?: string;
  lastVisitedSo5Competition?: string;
  lastVisitedArenaRarity?: Rarity;
};

export const useLastVisitedBoardView = () => {
  const { lifecycle, update, loading } = useLifecycle();
  const { sport } = useSportContext();

  const lastVisitedView = lifecycle?.[LIFECYCLE.lastVisitedBoardView]?.[sport];

  const updateBoardView = (partial: BoardViewUpdate) => {
    if (loading) return;
    update(LIFECYCLE.lastVisitedBoardView, {
      ...lifecycle?.[LIFECYCLE.lastVisitedBoardView],
      [sport]: {
        ...lastVisitedView,
        ...partial,
      },
    });
  };

  return {
    lastVisitedView,
    updateBoardView,
    loading,
  };
};
